<div class="modal-header"><h2 class="modal-title">Paddle Assignment</h2></div>
<div class="modal-body">
  @if (paddleUser) {
    <div class="m-2">
      <dx-form [formData]="paddleUser">
        <dxi-item dataField="created" [label]="{ text: 'Date' }"></dxi-item>
        <dxi-item [label]="{ text: 'Paddle #' }">
          <div *dxTemplate>
            <dx-select-box
              [(value)]="paddleUser.auctionPaddleId"
              [dataSource]="paddles"
              valueExpr="id"
              displayExpr="paddleNumber"
              [searchEnabled]="true"
              [disabled]="true"
            ></dx-select-box>
          </div>
        </dxi-item>
        <dxi-item [label]="{ text: 'Person' }">
          <div *dxTemplate>
            <dx-select-box
              [(value)]="paddleUser.personId"
              [dataSource]="people"
              valueExpr="id"
              displayExpr="displayNameLastFirst"
              [searchEnabled]="true"
              [showClearButton]="true"
              (onValueChanged)="personChanged($event)"
            ></dx-select-box>
          </div>
        </dxi-item>
        <dxi-item dataField="name" [label]="{ text: 'Name' }"></dxi-item>
        <dxi-item dataField="address" [label]="{ text: 'Address' }"></dxi-item>
        <dxi-item dataField="city" [label]="{ text: 'City' }"></dxi-item>
        <dxi-item dataField="state" [label]="{ text: 'State' }"></dxi-item>
        <dxi-item dataField="zip" [label]="{ text: 'Zip' }"></dxi-item>
        <dxi-item dataField="phone" [label]="{ text: 'Mobile' }"></dxi-item>
        <dxi-item dataField="email" [label]="{ text: 'Email' }"></dxi-item>
      </dx-form>
    </div>
  }
</div>
<div class="modal-footer">
  <button class="btn btn-success" (click)="save()">Save</button>
  <button class="btn btn-primary" (click)="close()">Close</button>
</div>
